module.exports = __webpack_public_path__ + "img/GYLFW_5.9b0fc120.jpg";